import type { TextareaHTMLAttributes } from "react";
import { cn } from "../../utils/cn";

type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement> & {
  hasError?: boolean;
};

export const Textarea = ({ className, hasError, ...props }: TextareaProps) => (
  <textarea
    className={cn(
      "w-full rounded-md border border-border bg-input text-sm text-foreground",
      "px-3 py-2 transition-all duration-200 placeholder:text-muted-foreground",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
      "focus-visible:bg-[rgb(var(--focus))]",
      "min-h-[120px] resize-y",
      hasError && "border-destructive focus-visible:ring-destructive",
      className
    )}
    {...props}
  />
);
